import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'InteractiveMapSection' })(
  ({ brandType, brandColors, breakpoints, type, typography }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: typography.pxToRem(20),
      paddingBottom: typography.pxToRem(20),
      backgroundColor: brandColors.white,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(22),
        paddingRight: typography.pxToRem(26),
        paddingTop: typography.pxToRem(29),
        paddingBottom: typography.pxToRem(40),
      },
    },
    heading: {
      ...type['44_medium'],
      marginBottom: typography.pxToRem(50),
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
      },
    },
    mainSvg: {
      overflow: 'visible',
      position: 'relative',
      left: typography.pxToRem(-0.5),
      height: typography.pxToRem(504),
      width: typography.pxToRem(789),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
        height: 'auto',
        width: 'auto',
      },
    },
    stateNotCovered: {
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      strokeOpacity: 20,
      strokeLinejoin: 'miter',
      strokeLinecap: 'square',
      strokeMiterlimit: 4,
      opacity: 0,
    },
  })
);

export default useStyles;
